import { render, staticRenderFns } from "./XFormControlSwitch.vue?vue&type=template&id=76e9a0d0&scoped=true&"
import script from "./XFormControlSwitch.vue?vue&type=script&lang=js&"
export * from "./XFormControlSwitch.vue?vue&type=script&lang=js&"
import style0 from "./XFormControlSwitch.vue?vue&type=style&index=0&id=76e9a0d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9a0d0",
  null
  
)

export default component.exports